import React, { memo, useEffect, useState } from "react";
import "./style.scss";
import { Col, List, Row, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { DEFAULT_OFFSET, ROUTER_PATH } from "../../common/constant";
import { products } from "../../services";
import InfiniteScroll from "react-infinite-scroller";
import ProductWishItem from "./productWishItem";
import { setTitlePage } from "../../utils/helper";
import { localizeRouteKey } from "../../shared/helpers";
import { Link } from "react-router-dom";

const ProfileProductWish = memo((props: any) => {
  const { t } = useTranslation();
  const [offset, setOffset] = useState(DEFAULT_OFFSET);
  const limit = 7;
  const [_products, setProducts] = useState<any[]>();
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    setTitlePage(t("title_page_products_wish"));

    if (!_products || !_products.length) {
      fetchData(offset, limit, (res: any) => {
        setTotal(res.total);
        setOffset(offset + limit);
        setLoading(false);
        setProducts(res.docs);
      });
    }
  }, []);

  const fetchData = (offset: any, limit: any, cb: any) => {
    setLoading(true);

    products.getProductsWishV2({ offset, limit }, (data, err) => {
      if (data) {
        cb(data);
      }
    });
  };

  const handleInfiniteOnLoad = () => {
    if (_products && _products.length === total) {
      setHasMore(false);
      setLoading(false);

      return;
    }

    fetchData(offset, limit, (res: any) => {
      const p = _products?.concat(res.docs);
      setProducts(p);
      setOffset(offset + limit);
      setLoading(false);
    });
  };

  const removeProduct = (code: string) => {
    const p = _products?.filter((item) => item.feature_code !== code);
    setProducts(p);
  };

  return (
    <Row justify="center" align="middle" className="kd-profile-container">
      <Col span={24}>
        <Row className="kd-go-to-home">
          <Link
            // onClick={() =>
            //   props.history.push(localizeRouteKey(ROUTER_PATH.HOME))
            // }
            to={localizeRouteKey(ROUTER_PATH.HOME)}>
            <img
              src="https://kdstore.s3-ap-southeast-1.amazonaws.com/static/imgs/arrow-tail.svg"
              alt=""
            />
            <span className="sub-content order-detail-bold">
              Quay lại trang chủ
            </span>
          </Link>
        </Row>
        <Row justify="center" align="middle">
          <span className="main-title kd-profile-title">{t("user_wish")}</span>
          {/* <span className="main-content kd-profile-go-back">
            Quay lại trang thông tin
          </span> */}
        </Row>
        {/* <Row justify="start" align="middle">
          
        </Row> */}
        <Row justify="center" align="middle">
          {loading && !_products ? (
            <div className="loading-container">
              <Spin />
            </div>
          ) : (
            <Row
              align="middle"
              justify="center"
              style={{
                width: "100%",
              }}
              className="filter-product-wrapper">
              <Col span={24} style={{ width: "100%" }}>
                <Row
                  justify="center"
                  align="middle"
                  className="filter-product-slider-wrapper">
                  <Col span={24} style={{ width: "100%" }}>
                    <InfiniteScroll
                      initialLoad={false}
                      pageStart={0}
                      loadMore={handleInfiniteOnLoad}
                      hasMore={!loading && hasMore}>
                      <List
                        className="filter-product-list product-wishes-list"
                        // grid={{ lg: 4, md: 3, sm: 2, xs: 1 }}
                        dataSource={_products}
                        renderItem={(item: any, i: number) => (
                          <ProductWishItem
                            {...props}
                            product={item}
                            removeProduct={removeProduct}
                            index={i}
                          />
                        )}></List>
                      {loading && hasMore && (
                        <div className="loading-container">
                          <Spin />
                        </div>
                      )}
                    </InfiniteScroll>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </Row>
      </Col>
    </Row>
  );
});

export default ProfileProductWish;
